__turbopack_context__.v({
  "button": "VsacPa_button",
  "disabled": "VsacPa_disabled",
  "is-destructive": "VsacPa_is-destructive",
  "is-secondary": "VsacPa_is-secondary",
});
